import React, { Component } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import cns from "classnames";
import {
  fetchTicketCode,
  getTicketCode,
  setTicketCode,
  getUserInfo,
} from "../../services/api.js";
import { userIsNotSubscribed, userPlan } from "../../user";
import {
  NYA_FREE,
  NYA_MONTHLY,
  NYA_UNLIMITEDV2_MONTHLY,
} from "../../util/contants/url_constants";

class MobileTicket extends Component {
  constructor(props) {
    super(props);
    this.state = { code: null, loading: false };
  }

  render() {
    const { ticket, onCopy, assignedCodes, isUserSubscribed, currentUserPlan, userInfo, addAssignedCodes, userData } = this.props;
    const { loading } = this.state;

    const date = moment.utc(ticket.date);
    const code = this.state.code || getTicketCode(`${userInfo.user_id}-${ticket.id}`);
    const notAllowedPlans = [NYA_FREE, NYA_MONTHLY, NYA_UNLIMITEDV2_MONTHLY];
    const planVerification = !notAllowedPlans.includes(currentUserPlan);
    const isSubscriptionTrial = userData && userData.isSubscriptionTrial;
    const showCode = isUserSubscribed && planVerification && code && !isSubscriptionTrial;

    if (isUserSubscribed && planVerification && !code && !isSubscriptionTrial) {
      assignedCodes &&
        assignedCodes.map((c) => {
          if (c.ticket === ticket.id) {
            setTicketCode(`${userInfo.user_id}-${ticket.id}`, c.code);
            this.setState({ code: c.code });
          }
        });
    }

    const onCodeButtonClick = () => {
      if (!isUserSubscribed || !planVerification || isSubscriptionTrial) {
        window.subsTicketMonthly();
        return;
      }
      if (code) {
        onCopy(code);
      } else {
        const { staticCode } = ticket;
        if (staticCode) {
          this.setState({ code: staticCode, loading: false });
          addAssignedCodes({ ticket: ticket.id, code: staticCode });
        } else {
          this.setState({ loading: true });
          fetchTicketCode(ticket.id, ticket.flexibleCodeSource)
            .then((result) => {
              this.setState({ code: result.body.code, loading: false });
              addAssignedCodes({ ticket: ticket.id, code: result.body.code });
            })
            .catch(() => this.setState({ loading: false }));
        }
      }
    };

    return (
      <div
        className={cns("ticket ticket--nya", { "ticket--soldOut": ticket.soldOut })}
      >
        <div className="month">{date.format("MMM")}</div>
        <div className="number">{date.format("DD")}</div>
        <div className="year">{date.format("YYYY")}</div>
        <div className="ticket-title">{ticket.title}</div>
        <div className="ticket-descrOne">{ticket.description}</div>
        <div className="ticket-descrTwo">
          <label>{ticket.venue}</label>
          <label>{ticket.location}</label>
        </div>
        {showCode && (
          <div className="ticket-codeSection">
            <label>
              CODE: <label className="code">{code}</label>
            </label>
            <label>{ticket.codeLabel}</label>
          </div>
        )}
        {ticket.buyLinkEnabled && ticket.buyLinkUrl && (
          <div
            className={cns("button ticket-button", { disabled: ticket.soldOut })}
            onClick={() => { if (!ticket.soldOut) window.open(ticket.buyLinkUrl); }}
          >
            BUY TICKETS
          </div>
        )}
        {(ticket.flexibleCodeSource || ticket.staticCode) && (
          <div
            className={cns("button code-button", { white: showCode }, { disabled: ticket.soldOut || loading })}
            onClick={!loading && !ticket.soldOut && onCodeButtonClick}
          >
            {showCode ? "COPY CODE" : loading ? "" : "GET CODE"}
          </div>
        )}
        {loading && (
          <div className="loading-indicator-wrapper">
            <div className="loading-indicator" />
          </div>
        )}
      </div>
    );
  }
}

class MobileTickets extends Component {
  render() {
    const { data, accountPage, entryID, addAssignedCodes, userData } = this.props;
    const isUserSubscribed = !userIsNotSubscribed();
    const currentUserPlan = userPlan();
    const userInfo = getUserInfo();
    const tickets = (data && data.tickets) || [];
    const assignedCodes = (data && data.assignedCodes) || [];

    const onCopy = (code) => {
      const target = document.createElement("textarea");
      target.style.position = "absolute";
      target.style.left = "-9999px";
      target.style.top = "0";
      document.body.appendChild(target);
      target.textContent = code;
      target.focus();
      target.setSelectionRange(0, target.value.length);
      try { document.execCommand("copy"); } catch (e) { /* noop */ }
      document.body.removeChild(target);
    };

    return (
      <div id="account-menu-container">
        <div className="one column row links subscription-overview">
          <div className="left aligned column presale">
            <p>
              NYA Subscribers get the best seats first. Click "Get Code" to
              reveal your unique pre-sale code. Enjoy the show(s)
            </p>
            <p>
              If you are not a subscriber,{" "}
              <Link to="/account?screen=plans" style={{ color: "#046bc4", fontWeight: "bold", fontSize: "20px" }}>
                CLICK HERE
              </Link>{" "}
              to become one. For code issues{" "}
              <Link to="/contact" style={{ color: "#046bc4", fontWeight: "bold", fontSize: "20px" }}>
                contact
              </Link>{" "}
              NYA. For purchase issues please contact the ticket vendor.
            </p>
          </div>
        </div>
        <div className="tickets-panel">
          {tickets.map((ticket, ind) => (
            <MobileTicket
              ticket={ticket}
              key={`ticket-${ind}`}
              onCopy={onCopy}
              userInfo={userInfo}
              isUserSubscribed={isUserSubscribed}
              currentUserPlan={currentUserPlan}
              assignedCodes={assignedCodes}
              addAssignedCodes={addAssignedCodes}
              userData={userData}
            />
          ))}
          {tickets.length === 0 && (
            <div style={{ padding: "2rem", textAlign: "center" }}>
              No presale tickets available at this time.
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default MobileTickets;
